const RouteEnum = {
    INDEX: () => '/',

    UZIVATEL_SEZNAM: () => '/uzivatele',
    UZIVATEL_DETAIL: (id: number | string = ':id') => `/uzivatel/${id}`,

    NASTAVENI: () => '/nastaveni',

    STROM: () => '/strom',
    STROM_DETAIL: (id: number | string = ':id') => `/strom/${id}`,

    FAQ: () => '/faq',
    FAQ_QUESTION_DETAIL: (id: number | string = ':id') => `/faq/otazka/${id}`,
    FAQ_ANSWER_DETAIL: (id: number | string = ':id') => `/faq/odpoved/${id}`,
    FAQ_DOMAIN_DETAIL: (id: number | string = ':id') => `/faq/domena/${id}`,

    FORB: () => '/zakazana-temata',
    FORB_QUESTION_DETAIL: (id: number | string = ':id') => `/zakazana-temata/otazka/${id}`,
    FORB_ANSWER_DETAIL: (id: number | string = ':id') => `/zakazana-temata/odpoved/${id}`,

    SMALLTALK: () => '/small-talk',
    SMALLTALK_QUESTION_DETAIL: (id: number | string = ':id') => `/small-talk/otazka/${id}`,
    SMALLTALK_ANSWER_DETAIL: (id: number | string = ':id') => `/small-talk/odpoved/${id}`,

    KONFIGURACE: () => '/configChatbot',

    KONVERZACE: () => '/konverzace',
    KONVERZACE_DETAIL: () => `/konverzace/detail`,

    LOGOUT: () => '/uzivatel/odhlaseni',
};

export default RouteEnum;